<div class="phone-input__shell">
  <input
    #telInput
    type="tel"
    class="phone-input__native"
    [id]="inputId"
    [attr.placeholder]="placeholder"
    autocomplete="tel"
    inputmode="tel" />
</div>
